// src/redux/apiEndpoints/apiEndpoints.js

export const endpoints = {
  ncodes: '/ncodes',
  reorderNcodes: '/ncodes/reorder',
  getResult: '/ncodes/get-result',
  getInnerDriveQuizResult: '/innerDrive/submit',
  getPersonalityTestOptions: '/personalitytest/options',
  submitPersonalityTest: '/personalitytest/submit',
  submitinnerNeedsTest: '/inner-need/submit',
  submitTraitTest: '/traistest/submit ',
  checkTokenExpiry: "/public/interview-candidate/expiry_check",
  roleList: "/access-groups",
  removeCompanyCoach: "/company/coach/remove/{coach_id}",
  login: "/auth/login",
  register: "/auth/register",
  logout: "/auth/logout",
  forgotPassword: "/auth/forgot-password",
  resetPassword: "/auth/reset-password",
  verifyEmail: "/auth/verify-email",
  updateProfile: "/auth/update-profile",
  changePassword: "/auth/change-password",
  refreshToken: "/auth/refresh-token",

  getCountryList: "/countries",
  getStateList: "/states",
  getCityList: "/cities",
  searchPublicCities: "/public/cities/search",

  addCoach: "/coach/add",
  getCoachList: "/coach/listing",
  getCoachDetail: "/coach/detail",
  updateCoach: "/coach/edit",
  deleteCoach: "/coach/delete",
  getCoachListAll: "/coach/list-all",
  // Get companies for a particular coach (paginated)
  getCoachCompanies: "/coach/{coachId}/companies",

  addAssignments: "/assignment/add",
  updateAssignments: "/assignment/edit",
  getAssignmentsList: "/assignment/listing",
  getAssignmentsDetail: "/assignment/detail",
  deleteAssignments: "/assignment/delete",
  archiveAssignments: "/assignment/archive",
  addSupportedDocument: "/supported-documents/add",
  updateSupportedDocument: "/supported-documents/edit",
  getSupportedDocumentsList: "/supported-documents/listing",
  getSupportedDocumentById: "/supported-documents/detail",
  archiveSupportedDocument: "/supported-documents/archive",

  addSessionMaster: "/session/add",
  updateSessionMaster: "/session/edit",
  getSessionMasterList: "/session/listing",
  getSessionMasterById: "/session-master/detail",
  archiveSessionMaster: "/session/archive",

  addCompany: "/company/add",
  updateCompany: "/company/update",
  getCompanyList: "/company/list",
  getCompanyDetail: "/company",
  deleteCompany: "/company/delete",
  assignCoach: "/company/assign-coaches",
  getCompanyCoaches: "/company/:id/coaches",
  getCompanyActivityLogs: "/company/company-activity-logs",

  addEmployee: "/company/employees",
  updateEmployee: "/company/employees",
  deleteEmployee: "/company/employees/delete",
  getEmployeesList: "/company/employees",
  getEmployeeDetail: "/company/employees",
  getHrEmployee: "/company/employees/hr",
  importEmployeesCsv: "/company/employees/import-csv",
  lockCompanyEmployee: "/company/employee/lock",
  companiesAssociatedCoach: "/company/companies_associated_coach",
  // Batches endpoints
  addBatches: "/batches/create",
  updateBatches: "/batches/update",
  getBatchesList: "/batches/list",
  getBatchesDetail: "/batches/details",
  deleteBatches: "/batches/delete",
  unassignedEmployees: "/batches/unassigned-employees",
  addemployee: "/batches/add-employees",
  removeEmployee: "/batches/remove-employees",
  getCompanyEmployeeInfo: "/company-employee/{companyEmployeeId}/info",
  addManagement: "/company/management/add",
  updateManagement: '/company/management/edit/{company_employee_id}',
  getManagementsList: "/company/management",
  deleteManagement: "/company/management/delete/{company_employee_id}",
  getManagementDetail: "",
  importManagementsCsv: "",

  // Company Session endpoints
  createCompanySession: "/company/{company_id}/sessions",
  getCompanySessions: "/company/sessions",
  updateCompanySession: "/company/{company_id}/sessions/{session_id}",
  deleteCompanySession: "/company/{company_id}/sessions/{session_id}",
  getCompanySessionDetail: "/company/{company_id}/sessions/{company_session_id}",

  // New endpoints for company session operations
  getParticularSessionDetails: "/company/sessions/particular-details",
  enableToolAccess: "/company/sessions/enable-tool",
  enableSupportDocument: "/company/sessions/enable-support-document",
  enableAssignment: "/company/sessions/enable-assignment",
  enableCompanySession: "/company/sessions/enable",

  createInterviewCandidate: "/interview-candidate",
  getInterviewCandidateList: "/interview-candidate",
  cancelInterviewCandidate: "/interview-candidate/cancel",
  getCandidateAssessmentLink: "/interview-candidate/assessment-link", // NEW ENDPOINT


  // Company Quota Endpoints
  addCompanyQuota: "/company/quota",

  getEmployeeSessions: "/company-employee/my-sessions",
  getEmployeeTools: "/company-employee/my-tools",
  getSessionAssessmentLink: "/company-employee/session/{sessionId}/assessment-link",
  getSessionAssignmentResult: "/company-employee/assignments/{sessionId}/result",
  // Employee Assignments & Documents Endpoints
  getEmployeeAssignments: "/company-employee/my-assignments",
  getEmployeeDocuments: "/company-employee/my-documents",
  getSessionDocumentLink: "/company-employee/session/{sessionId}/document-link",
  getAssignmentQuestions: '/company-employee/assignment/questions/{sessionAssignmentId}',
  submitAssignmentAnswers: '/company-employee/assignments/submit',
  getAssignmentAnswers: '/company-employee/assignment/answers/{sessionAssignmentId}',
  getCoachCompaniesByMonth: "/coach/{coach_id}/companies-by-month",
  createCompanyAdhoc: "/company/adhoc/add",
  getCompanyAdhocListing: "/company/adhoc/listing",
  getCompanyAdhocToolsCandidatesCount: "/company/adhoc/tools/candidates/count",
  getCompanyAdhocDetail: "/company/adhoc/{companyId}",
  editCompanyAdhoc: "/company/adhoc/edit/{companyId}",
  resendHrInvite: '/company/{companyId}/resend-hr-invite',
  getCompanyAdhocTools: "/company/adhoc/tools/{companyId}",
  archiveCompanyAdhoc: "/company/adhoc/archive/{companyId}",


  createScienceOfSelf: "/science-of-self/create",
  getScienceOfSelfList: "/science-of-self",
  getScienceOfSelfById: "/science-of-self/{id}",
  updateScienceOfSelf: "/science-of-self/update/{science_id}",
  deleteScienceOfSelf: "/science-of-self/delete/{science_id}",
  archiveScienceOfSelf: "/science-of-self/archive/{science_id}",

  addScienceOfSelfSession: "/science-of-self/add-session",
  getScienceOfSelfSessions: "/science-of-self/{science_id}/sessions",
  enableDisableTool: "/science-of-self/sessions/enable-tool",
  enableDisableAssignment: "/science-of-self/sessions/enable-assignment",
  enableDisableSupportDocument: "/science-of-self/sessions/enable-support-document",
  getScienceOfSelfSessionDetails: "/science-of-self/sessions/{science_of_self_session_id}/details",
enableDisableScienceOfSelfSession: "/science-of-self/sessions/enable",

  createSalesTrainingCompany: "/sales-training-company/create",
  getSalesTrainingCompanyList: "/sales-training-company",
  getSalesTrainingCompanyById: "/sales-training-company/{id}",
  updateSalesTrainingCompany: "/sales-training-company/update/{stc_id}",
  deleteSalesTrainingCompany: "/sales-training-company/delete/{stc_id}",
  archiveSalesTrainingCompany: "/sales-training-company/archive/{stc_id}",

  addSalesTrainingSession: "/sales-training-company/add-session",
  getSalesTrainingSessions: "/sales-training-company/{stc_id}/sessions",
  enableDisableSalesTrainingTool: "/sales-training-company/sessions/enable-tool",
  enableDisableSalesTrainingAssignment: "/sales-training-company/sessions/enable-assignment",
  enableDisableSalesTrainingSupportDocument: "/sales-training-company/sessions/enable-support-document",
  getSalesTrainingSessionDetails: "/sales-training-company/sessions/{sales_training_company_session_id}/details",
  enableDisableSalesTrainingSession: "/sales-training-company/sessions/enable",
  submitSalesTrainingAssignment: "/sales-training-company/sessions/submit-assignment",
  getSalesTrainingAssessmentLink: "/sales-training-company/sessions/{sales_training_company_session_id}/assessment-link",

  getCompanyProspectGeneratedUrl: "/company/prospect/generate-url",
  getCompanyUrl:"/company/prospect/generatedUrl",
  getCompanyProspectListing: "/company/prospect/listing",
  getCompanyProspectDetail: "/company/prospect/detail/{company_id}",
  createCompanyProspect: "/company/prospect/add",
  updateCompanyProspect: "/company/prospect/update/{company_id}",
  deleteCompanyProspect: "/company/prospect/delete/{company_id}",
  getCompanyEmployees: "/company/prospect/candidates/{company_id}",
  getCompanyEmployeeDetail: "/company/prospect/candidates/{company_id}/{candidate_id}",


  batchesOptions:"/batches/options",
  moveBatchEmployees:"/batches/move-employees",
convertCompanyProspect: "/company/prospect/convert/{company_id}",

// ✅ Settings
getAdminProfile: "/settings/profile",
updateAdminProfile: "/settings/profile",
uploadProfileImage: "/settings/profile-image",
deleteProfileImage: "/settings/profile-image",
changePassword: "/settings/change-password",
 uploadCompanyLogo: "/settings/company-logo",
  deleteCompanyLogo: "/settings/company-logo",


// Assessment Results
getAssessmentResults: "/assessment-results",

// Notifications
getNotifications: "/notifications",
getUnreadNotificationCount: "/notifications/unread-count",
markNotificationAsRead: "/notifications/{id}/read",
markAllNotificationsAsRead: "/notifications/read-all",
deleteNotification: "/notifications/{id}",

  // Session URL (public)
  checkSessionUrl: "/public/session-url/check",
  submitSessionUrl: "/public/session-url/submit",

  // Learning & Feedback
  submitLearningFeedback: "/feedback",
  getLearningFeedbackList: "/feedback",
  getLearningFeedbackById: "/feedback/{id}",
  deleteLearningFeedback: "/feedback/{id}",

};